// extracted by mini-css-extract-plugin
export var container = "nav-header-left-module--container--ec028";
export var logoIcon = "nav-header-left-module--logoIcon--f2dc1";
export var logoText = "nav-header-left-module--logoText--aadc1";